<template>
    <div class="px-6 py-4 bg-minplan-beige">
        <page-title :title="$t('agencies.deleteAgencyConfirmTitle')"></page-title>
    </div>

    <jet-form-section @submitted="activate()">
        <template #form>
            <div class="px-6 py-4">
                <p>{{ $t("agencies.deleteAgencyConfirmDesc") }}</p>
                <div v-if="affectedUsers.length > 0">
                    <p class="mb-2 text-sm text-gray-700">
                        {{ $t("agencies.affectedUsers") }}
                    </p>
                    <ul>
                        <li v-for="user in affectedUsers" :key="user">
                            {{ user }}
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">
                <button
                    @click="cancel"
                    type="button"
                    class="inline-block uppercase font-semibold text-xs tracking-widest"
                >
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    class="ml-3"
                >
                    {{ $t("actions.confirm") }}
                </primary-button>
            </div>
        </template>
    </jet-form-section>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import FormCard from "@/Shared/Components/FormCard";

export default defineComponent({
    props: ["agency", "affectedUsers"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        SwitchGroup,
        SwitchLabel,
        Switch,
        FormCard,
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        activate() {
            this.form.delete(
                this.route("admin.agencies.delete", { agency: this.agency.uuid }),
                {
                    preserveScroll: true,
                    onSuccess: () =>
                        this.$notify({
                            group: "success",
                            title: "actions.success",
                            text: "agencies.deleted",
                        }),
                }
            );
        },
    },
    setup(props) {
        const form = useForm({
            name: props.agency.name,
        });

        return { form };
    },
});
</script>

<style scoped></style>
